import { render } from "./App.vue?vue&type=template&id=ad97a35a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ad97a35a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__